import React, { useEffect, useState } from 'react';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { useLocation, useNavigate } from 'react-router-dom'

export default function Sucess(params) {
  const [relato, setRelato ] = useState(null)
  const location = useLocation()
  const nav = useNavigate()


  useEffect(() => {
    if(location.state !== null)
      setRelato(location.state.relato)
    else
      nav("/")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (
    <div>
      <Navbar/>
      <main className='flex mt-48 flex-col '>
        {
          relato !== null ?
          <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto h-[61vh]'>
            <div className='flex flex-col items-center gap-4'>
              <h1 className='text-2xl text-primary font-bold'>Obrigado, relato enviado com sucesso!</h1>
              <hr className='border border-background w-full'/>
              <div className='flex flex-col items-center text-secondary'>
                <span>Anote o protocolo do seu relato para acesso posterior ao link de acompanhamento</span>
                <span>O seu número de protocolo é</span>
                <h2 className='text-2xl text-primary font-semibold select-all'>{relato.uuid}</h2>
              </div>
              <hr className='border border-background w-full'/>
              <div className='flex flex-col text-secondary items-center'>
                <span>Para acompanhar seu relato <a className='text-primary underline font-semibold' href="/follow">Clique aqui</a> ou copie o link abaixo</span>
                <span className='select-all cursor-copy'>https://ouvidoria-mig.vercel.app/follow</span>
              </div>
            </div>
          </section>
          :
          <></>
        }
        
        <Footer />
      </main>
    </div>
  )
};
